import { createContext, useContext, useEffect, useState } from "react";
import api, { setToken } from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const tk = localStorage.getItem("token");
    if (!tk) { setLoading(false); return; }
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setToken(null)).finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    if (r.data.requires_otp) return { otp: true, email: r.data.email, dev_otp_hint: r.data.dev_otp_hint };
    setToken(r.data.token);
    setUser(r.data.user);
    return { otp: false, user: r.data.user };
  };

  const verifyOtp = async (email, otp) => {
    const r = await api.post("/auth/verify-otp", { email, otp });
    setToken(r.data.token);
    setUser(r.data.user);
    return r.data.user;
  };

  const register = async (data) => {
    const r = await api.post("/auth/register", data);
    setToken(r.data.token);
    setUser(r.data.user);
    return r.data.user;
  };

  const logout = () => { setToken(null); setUser(null); };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, login, verifyOtp, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
